var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInventory = function SvgInventory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 43,
    viewBox: "0 0 44 43"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M40.3 20.837V42.3H3.7V20.837h-3V10.432h42.6v10.405h-3Zm-2.6 0H6.3V39.7h31.4V20.837ZM3.3 13.032v5.205h37.4v-5.205H3.3Zm.4-5.366v-2.6h37.819v2.6H3.7Zm2.903-4.878v-2.6h32.23v2.6H6.602ZM18.3 27.993h8.4V26.69h-8.4v1.303Zm11-3.903v6.503H15.7V24.09h13.6Z"
  })));
};
export default SvgInventory;